export class MimeType {
  static APPLICATION_MP4 = 'application/mp4';

  static APPLICATION_MPD = 'application/dash+xml';

  static APPLICATION_M3U8 = 'application/x-mpegURL';
}
